import { IComponentOptions } from "angular";
import { GameProgramViewController } from "./controller";

export const vsComponentName = "epromGrid";

export const softwareProgramGridComponentOptions: IComponentOptions = {
  controller: GameProgramViewController,
  controllerAs: "epromGridController",
  template: require("!html-loader!./index.html").default,
  bindings: {},
};
